
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type ProductInformationDialogRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function ProductInformationDialogRT(): TemplateResult<ProductInformationDialogRTRootProps> {
    function mergeProps(inline, external) {
        var res = Object.assign({}, inline, external);
        if (inline.hasOwnProperty('style')) {
            res.style = _.defaults(res.style, inline.style);
        }
        if (inline.hasOwnProperty('className') && external.hasOwnProperty('className')) {
            res.className = external.className + ' ' + inline.className;
        }
        return res;
    }
    function repeatSplittedValue2(item, splittedValue, splittedValueIndex) {
        return [_createElement('div', {
                'className': 'info-block__text',
                'key': '18921'
            }, splittedValue)];
    }
    function repeatDot3(item, dot, dotIndex) {
        return _createElement('span', {
            'key': dot,
            'className': 'product-information__dot'
        });
    }
    function repeatDot4(item, dot, dotIndex) {
        return _createElement('span', {
            'key': dot,
            'className': 'product-information__dot'
        });
    }
    function repeatDot5(item, dot, dotIndex) {
        return _createElement('span', {
            'key': dot,
            'className': 'product-information__dot'
        });
    }
    function repeatDot6(item, dot, dotIndex) {
        return _createElement('span', {
            'key': dot,
            'className': 'product-information__dot'
        });
    }
    function scopeItem7() {
        var item = window.Convermax.getProductInformation();
        return _createElement('div', { 'className': 'dialog-container cm_dialog-drawer' }, _createElement('div', { 'className': 'dialog-content' }, _createElement('div', { 'className': 'dialog-header' }, _createElement('div', {
            'className': 'dialog-header-close',
            'data-cm-role': 'close'
        }, [_createElement('svg', {
                'className': 'cm_icon cm_icon-times',
                'height': '20px',
                'role': 'img',
                'viewBox': '0 0 22 22',
                'key': '2410'
            }, _createElement('path', { 'd': 'M1,1L21,21M21,1L1,21' }))])), _createElement('div', { 'className': 'dialog-body product-dialog' }, _createElement('div', { 'className': 'product-dialog__top' }, _createElement('div', { 'className': 'product-dialog__image' }, _createElement('img', {
            'src': item.images_image_standard1,
            'alt': item.name
        })), _createElement('div', { 'className': 'product-dialog__main' }, _createElement('div', mergeProps({ 'className': 'product-dialog__title' }, { dangerouslySetInnerHTML: { __html: typeof item.name === 'undefined' ? '' : item.name } })), _createElement('div', { 'className': 'product-dialog__subtitle' }, item.price), _createElement('a', {
            'className': 'product-dialog__button',
            'href': item.custom_url
        }, 'View Product'))), item.description || !item.category.some(c => c.includes('Gear') || c.includes('Accessories')) ? _createElement('div', {
            'className': 'product-dialog__info product-information__items-wrapper',
            'key': '1031'
        }, _createElement('div', { 'className': 'product-dialog__info-title' }, 'Product Information'), _createElement('div', { 'className': 'info-section' }, item['height-adjustment'] ? _createElement('div', {
            'className': 'info-block',
            'key': '1345'
        }, _createElement('div', { 'className': 'info-block__title' }, '\n              Height Adjustments: ', _createElement('span', { 'className': 'info-block__title-value' }, item['height-adjustment'])), _createElement('div', { 'className': 'info-block__text' }, '\n              Minimal: +5 - 20 mm', _createElement('br', {}), 'Moderat: 15 - 45 mm', _createElement('br', {}), 'Maximum: 35 - 80 mm\n            ')) : null, item.fitment_notes ? _createElement.apply(this, [
            'div',
            {
                'className': 'info-block',
                'key': '1765'
            },
            _createElement('div', { 'className': 'info-block__title' }, 'Fitment Notes'),
            _map(item.fitment_notes[0].split('\n'), repeatSplittedValue2.bind(this, item))
        ]) : null, item['everyday-use'] ? _createElement('div', {
            'className': 'info-block product-information__item',
            'data-value': item['everyday-use'],
            'key': '2097'
        }, _createElement('div', { 'className': 'info-block__title' }, 'Everyday Use'), _createElement('div', { 'className': 'info-block__text' }, '\n              The higher the value, the more unrestricted and comfortable the vehicle can be used in everyday\n              life', _createElement('br', {}), '- including ground clearance, driving dynamics and parts certificates.\n            '), _createElement.apply(this, [
            'div',
            { 'className': 'product-information__dots' },
            _map([
                0,
                1,
                2,
                3,
                4,
                5
            ], repeatDot3.bind(this, item))
        ])) : null, item.comfort ? _createElement('div', {
            'className': 'info-block product-information__item',
            'data-value': item.comfort,
            'key': '2764'
        }, _createElement('div', { 'className': 'info-block__title' }, 'Comfort'), _createElement('div', { 'className': 'info-block__text' }, '\n              A high value stands for particularly well-balanced suspension and effective damping of bumps and\n              noise.\n            '), _createElement.apply(this, [
            'div',
            { 'className': 'product-information__dots' },
            _map([
                0,
                1,
                2,
                3,
                4,
                5
            ], repeatDot4.bind(this, item))
        ])) : null, item.handling ? _createElement('div', {
            'className': 'info-block product-information__item',
            'data-value': item.handling,
            'key': '3318'
        }, _createElement('div', { 'className': 'info-block__title' }, 'Handling'), _createElement('div', { 'className': 'info-block__text' }, '\n              The higher the value, the more precise, stable and dynamic the vehicle reacts to steering\n              commands and bumps in the road.\n            '), _createElement.apply(this, [
            'div',
            { 'className': 'product-information__dots' },
            _map([
                0,
                1,
                2,
                3,
                4,
                5
            ], repeatDot5.bind(this, item))
        ])) : null, item['track-performance'] ? _createElement('div', {
            'className': 'info-block product-information__item',
            'data-value': item['track-performance'],
            'key': '3893'
        }, _createElement('div', { 'className': 'info-block__title' }, 'Track Performance'), _createElement('div', { 'className': 'info-block__text' }, '\n              A high value stands for maximum racetrack performance with precise handling, high cornering\n              speed and direct feedback\n            '), _createElement.apply(this, [
            'div',
            { 'className': 'product-information__dots' },
            _map([
                0,
                1,
                2,
                3,
                4,
                5
            ], repeatDot6.bind(this, item))
        ])) : null)) : null)));
    }
    return scopeItem7.apply(this, []);
}
        export const componentNames = []